import { createContext } from 'preact'
import { useContext, useReducer } from 'preact/hooks'
import { html } from 'htm/preact'

export const AppContext = createContext(null)

export const SET_INGREDIENTS = 'SET_INGREDIENTS'
export const SET_RECIPES = 'SET_RECIPES'
export const SET_THEME = 'SET_THEME'
export const SET_TOKEN = 'SET_TOKEN'
export const LOGOUT = 'LOGOUT'

function reducer(state, action) {
  switch (action.type) {
    case SET_INGREDIENTS:
      return { ...state, ingredients: action.payload }
    case SET_RECIPES:
      return { ...state, recipes: action.payload }
    case SET_THEME:
      return { ...state, theme: action.payload }
    case SET_TOKEN:
      return { ...state, token: action.payload }
    case LOGOUT:
      return { ...state, token: null, ingredients: [], recipes: [] }
    default:
      return state
  }
}

const persistedTheme = localStorage.getItem('mc-theme') || 'system'

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, {
    ingredients: [],
    recipes: [],
    theme: persistedTheme,
    token: null,
  })
  return html`<${AppContext.Provider} value=${[state, dispatch]}>${children}</${AppContext.Provider}>`
}

export function useAppState() {
  return useContext(AppContext)
}